export default function Loader({ show }: { show: boolean }) {
  return show ? (
    <div className="loading-container">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : null;
}
